export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-board/index.js